import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_CONFIG from '../config/api';
import Sidebar from '../Sidebar';
import CadastrarLojaModal from './CadastrarLojaModal';

const GerenciarLojas = ({ onLogout }) => {
  const navigate = useNavigate();
  const [lojas, setLojas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [lojaParaEditar, setLojaParaEditar] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Verificar autenticação e permissão
    const userData = localStorage.getItem('user');
    const parsedUser = userData ? JSON.parse(userData) : null;
    
    if (!parsedUser || (parsedUser.tipo !== 'super_admin' && parsedUser.cargo !== 'Admin')) {
      window.location.href = '/dashboard';
      return;
    }
    
    setUser(parsedUser);
    carregarLojas();
  }, []);

  const carregarLojas = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/lojas`, {
        headers: { 'x-auth-token': token }
      });
      
      if (response.data.success) {
        setLojas(response.data.data);
      }
    } catch (error) {
      console.error('Erro ao carregar lojas:', error);
      console.error('Erro ao carregar lista de lojas:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditarLoja = (loja) => {
    setLojaParaEditar(loja);
    setMostrarModal(true);
  };

  const handleNovaLoja = () => {
    setLojaParaEditar(null);
    setMostrarModal(true);
  };

  const handleAcessarLoja = (loja) => {
    localStorage.setItem('lojaContexto', JSON.stringify({ id: loja._id, nome: loja.nome, codigo: loja.codigo }));
    if ((loja.codigo || '').toLowerCase() === 'premium-beef-sorocaba') {
      localStorage.setItem('premiumBeefOpenUsers', '1');
    } else {
      localStorage.removeItem('premiumBeefOpenUsers');
    }
    navigate('/');
  };

  const handleModalSuccess = () => {
      carregarLojas();
      setMostrarModal(false);
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f7fafc' }}>
      <Sidebar user={user} onLogout={onLogout} />
      
      <main style={{ flex: 1, padding: '30px', overflowY: 'auto' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          
          <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
            <div>
              <h1 style={{ fontSize: '28px', color: '#2d3748', margin: '0 0 8px 0' }}>Gerenciamento de Lojas</h1>
              <p style={{ color: '#718096', margin: 0 }}>Administre as unidades e configurações do sistema.</p>
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                onClick={() => navigate('/admin/licensa')}
                style={{
                  background: '#ed8936',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 4px 6px rgba(237, 137, 54, 0.2)',
                  transition: 'background 0.3s'
                }}
                onMouseEnter={(e) => e.target.style.background = '#dd6b20'}
                onMouseLeave={(e) => e.target.style.background = '#ed8936'}
              >
                🔑 Gerenciar Licensa
              </button>
              <button
                onClick={handleNovaLoja}
                style={{
                  background: '#3182ce',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 4px 6px rgba(49, 130, 206, 0.2)',
                  transition: 'background 0.3s'
                }}
                onMouseEnter={(e) => e.target.style.background = '#2c5aa0'}
                onMouseLeave={(e) => e.target.style.background = '#3182ce'}
              >
                + Nova Loja
              </button>
            </div>
          </header>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px', color: '#718096' }}>Carregando lojas...</div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '24px' }}>
              {lojas.map(loja => (
                <div key={loja._id} style={{
                  background: 'white',
                  borderRadius: '12px',
                  padding: '24px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                  border: '1px solid #e2e8f0',
                  transition: 'transform 0.2s',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                  <div style={{ 
                      position: 'absolute', 
                      top: 0, 
                      left: 0, 
                      width: '100%', 
                      height: '6px', 
                      background: loja.status === 'ativa' ? '#48bb78' : '#e53e3e' 
                  }} />
                  
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                    <div>
                        <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#2d3748', margin: 0 }}>{loja.nome}</h2>
                        <span style={{ 
                            fontSize: '12px', 
                            color: '#718096', 
                            background: '#edf2f7', 
                            padding: '2px 8px', 
                            borderRadius: '4px',
                            marginTop: '4px',
                            display: 'inline-block'
                        }}>
                            #{loja.codigo}
                        </span>
                    </div>
                    
                    <span style={{ 
                        fontSize: '12px', 
                        fontWeight: 'bold', 
                        padding: '4px 10px', 
                        borderRadius: '20px', 
                        background: loja.status === 'ativa' ? '#c6f6d5' : '#fed7d7',
                        color: loja.status === 'ativa' ? '#2f855a' : '#c53030'
                    }}>
                        {loja.status.toUpperCase()}
                    </span>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px', color: '#4a5568', fontSize: '14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span>📍 {loja.endereco?.cidade} - {loja.endereco?.estado}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span>🏢 {loja.endereco?.bairro}</span>
                    </div>
                  </div>

                  <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div style={{ fontSize: '12px', color: '#718096' }}>
                          Criada em: {loja.data_criacao ? new Date(loja.data_criacao).toLocaleDateString() : '-'}
                      </div>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        {(loja.codigo || '').toLowerCase() === 'premium-beef-sorocaba' ? (
                          <button 
                            onClick={() => handleAcessarLoja(loja)}
                            style={{
                                background: '#2563eb',
                                border: 'none',
                                padding: '6px 12px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '13px',
                                color: 'white',
                                fontWeight: '500'
                            }}
                            title="Abrir usuários desta loja"
                          >
                              👥 Usuários
                          </button>
                        ) : (
                          <>
                            <button 
                              onClick={() => handleAcessarLoja(loja)}
                              style={{
                                  background: '#3182ce',
                                  border: 'none',
                                  padding: '6px 12px',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontSize: '13px',
                                  color: 'white',
                                  fontWeight: '500'
                              }}
                              title="Acessar painel desta loja"
                            >
                                🔗 Acessar
                            </button>
                            <button 
                              onClick={() => handleEditarLoja(loja)}
                              style={{
                                  background: 'white',
                                  border: '1px solid #cbd5e0',
                                  padding: '6px 12px',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontSize: '13px',
                                  color: '#4a5568',
                                  fontWeight: '500'
                              }}
                            >
                                ⚙️ Editar
                            </button>
                          </>
                        )}
                      </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

      {mostrarModal && (
        <CadastrarLojaModal 
            onClose={() => setMostrarModal(false)} 
            onSuccess={handleModalSuccess}
            lojaParaEditar={lojaParaEditar}
        />
      )}
    </div>
  );
};

export default GerenciarLojas;
